module.exports = __webpack_public_path__ + "static/img/aicon39.7d24788.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aicon39.png
// module id = 1436
// module chunks = 3